import {
    DESTROY_TOKEN,
    LOGIN,
    LOGOUT,
    SET_ACCESS_TOKEN,

} from "@/core/store/modules/auth/constants";
import api from "@/core/services/api/api.service"
import {DESTROY_ACCOUNT, SET_ACCOUNT} from "@/core/store/modules/account/constants";
import {REFRESH_CAPTCHA} from "@/core/store/modules/captcha/constants";
export default {
    [LOGIN](context, credentials) {
        return new Promise((resolve, reject) => {
            api.waiting('login').post(`/panel/login`, credentials)
                .then((response) => {
                    if (response.data.success) {
                        context.commit(SET_ACCESS_TOKEN, response.data.access_token);
                        context.commit(SET_ACCOUNT, response.data.company);
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
                .catch((error) => {
                    context.dispatch(REFRESH_CAPTCHA)
                    reject(error)
                })
        })
    },

    [LOGOUT](context) {
        if (context.getters.isAuthenticated) {
            // pusher.disconnect()
            return new Promise((resolve, reject) => {
                api.waiting('logout').post(`panel/logout`)
                    .then((response) => {
                        context.commit(DESTROY_TOKEN);
                        context.commit(DESTROY_ACCOUNT);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.commit(DESTROY_TOKEN);
                        context.commit(DESTROY_ACCOUNT);
                        reject(error)
                    })
            })
        }
    }

}